"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugSurfaceUtils = void 0;
var DebugSurfaceCleanupSystem_1 = require("./DebugSurfaceCleanupSystem");
var DebugSurfaceDrawingSystem_1 = require("./DebugSurfaceDrawingSystem");
/**
 * Helper class that helps the user set up DebugSurface drawing.
 */
var DebugSurfaceUtils = /** @class */ (function () {
    function DebugSurfaceUtils() {
    }
    /**
     * Enables all systems needed for DebugSurface drawing. This will create and register the needed system.
     * There is no check if the systems are already available. If you want to dispose of the viewer or just
     * disable the systems again, call {@link disableDebugSurfaceDrawing}
     * @param viewer
     * @param entityManager
     */
    DebugSurfaceUtils.enableDebugSurfaceDrawing = function (viewer, entityManager) {
        var drawingSystem = new DebugSurfaceDrawingSystem_1.DebugSurfaceDrawingSystem(viewer, entityManager);
        entityManager.registerSystem(drawingSystem);
        var cleanupSystem = new DebugSurfaceCleanupSystem_1.DebugSurfaceCleanupSystem(entityManager);
        entityManager.registerSystem(cleanupSystem);
    };
    /**
     * Disables and unregisters the systems needed for DebugSurface drawing. If the systems aren't registered,
     * nothing will happen.
     */
    DebugSurfaceUtils.disableDebugSurfaceDrawing = function (entityManager) {
        this.disableSystem(DebugSurfaceDrawingSystem_1.DebugSurfaceDrawingSystem.ID, entityManager);
        this.disableSystem(DebugSurfaceCleanupSystem_1.DebugSurfaceCleanupSystem.ID, entityManager);
    };
    DebugSurfaceUtils.disableSystem = function (systemID, entityManager) {
        var system = entityManager.getSystemsRegistered().find(function (it) {
            return it.id === systemID;
        });
        if (system) {
            entityManager.unregisterSystem(system);
        }
    };
    return DebugSurfaceUtils;
}());
exports.DebugSurfaceUtils = DebugSurfaceUtils;
//# sourceMappingURL=DebugSurfaceUtils.js.map